import StarrySkyBackground from "@/components/StarrySkyBackground";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { BookOpenCheck, Wand2, WandSparkles } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const SubscriptionComplete = () => {
  const navigate = useNavigate();
  const [showSparkles, setShowSparkles] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowSparkles(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex items-center justify-center p-4">
      <StarrySkyBackground
        showAurora={true}
        showClouds={true}
        showShootingStar={false}
      />
      <Card className="relative w-full max-w-2xl p-8 space-y-8 overflow-hidden">
        {/* Celebration animations */}
        <div className="absolute inset-0 pointer-events-none">
          {showSparkles && (
            <>
              <div className="absolute delay-75 top-24 left-1/4 animate-bounce">
                <WandSparkles className="w-8 h-8 text-purple-400" />
              </div>
              <div className="absolute top-24 right-1/4 animate-bounce">
                <WandSparkles className="w-8 h-8 text-indigo-400" />
              </div>
            </>
          )}
        </div>

        {/* Main content */}
        <div className="relative space-y-6 text-center">
          <div className="flex justify-center mb-6">
            <div className="p-4 bg-purple-100 rounded-full">
              <BookOpenCheck className="w-12 h-12 text-purple-600" />
            </div>
          </div>

          <h1 className="text-3xl font-bold text-gray-900 dark:text-sky-50">
            Welcome to Your Storytelling Journey!
          </h1>

          <p className="max-w-md mx-auto text-lg text-sky-800 dark:text-sky-400">
            Your magical adventure begins now. Let's create wonderful stories
            that will spark young imaginations!
          </p>

          <div className="pt-8 space-y-4">
            <Button
              onClick={() => navigate("/create")}
              className="w-full bg-primary sm:w-auto"
            >
              <Wand2 className="w-4 h-4 mr-2" />
              Create A Story
            </Button>

            <p className="text-sm text-sky-800 dark:text-sky-400">or</p>

            <Button
              variant="outline"
              onClick={() => navigate("/examples")}
              className="w-full sm:w-auto"
            >
              View Story Examples
            </Button>
          </div>
        </div>

        {/* Features reminder */}
        <div className="pt-8 mt-12 border-t border-gray-100">
          <div className="grid grid-cols-1 gap-6 text-center md:grid-cols-3">
            <div>
              <h3 className="font-medium text-gray-900 dark:text-sky-50">
                Custom Characters
              </h3>
              <p className="text-sm text-sky-800 dark:text-sky-400">
                Create unique characters for your stories
              </p>
            </div>
            <div>
              <h3 className="font-medium text-gray-900 dark:text-sky-50">
                Multiple Art Styles
              </h3>
              <p className="text-sm text-sky-800 dark:text-sky-400">
                Choose from various artistic themes
              </p>
            </div>
            <div>
              <h3 className="font-medium text-gray-900 dark:text-sky-50">
                Age-Appropriate
              </h3>
              <p className="text-sm text-sky-800 dark:text-sky-400">
                Stories tailored to your child's age
              </p>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SubscriptionComplete;
